import { render, staticRenderFns } from "./ValuationForm.vue?vue&type=template&id=5cc83914"
import script from "./ValuationForm.vue?vue&type=script&lang=js"
export * from "./ValuationForm.vue?vue&type=script&lang=js"
import style0 from "./ValuationForm.vue?vue&type=style&index=0&id=5cc83914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports